import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SharedService } from 'src/app/shared/services/shared.service';


@Component({
    selector: 'app-white-source-license',
    imports: [],
    templateUrl: './white-source-license.component.html',
    styleUrl: './white-source-license.component.scss'
})
export class WhiteSourceLicenseComponent {
        htmlContent: SafeHtml;

        constructor(private sanitizer: DomSanitizer, private sharedService: SharedService) {
                //This will not load the app-navigation-bar component here
                this.sharedService.setHideNavbar(true);

        }

        ngOnInit(): void {
                const whiteSourceHTMLTemplate = `<!DOCTYPE html>
<html>
<head>
    <meta charset="UTF-8">
</head>
<body style="font-family: calibri light;">
<div style="font-size: 40px;text-align: center;background: aliceblue;">Attribution Report releases/FY27R1_M3_Oracle-Ascend-Test-AI-UI</div>
<div style="font-size: 32px; text-align: left;"></div>
        <br><br>
        <div style="padding: 10px 21px; font-size: 14px;">This application uses certain open source software. As required by the terms of the open source license applicable to such open source software, we are providing you with the following notices:</div>
        <div style="border-bottom: 2px solid #616161; box-shadow: 0 1px 1px #ccc;">
            <div style="font-size: 32px; text-align: left;">SUMMARY</div>
        </div>
        <div style="padding-top: 15px;"/>
        <table border="3">
            <tbody>
            <tr>
                <td width="50">
                    <div style="background: aliceblue; font-size: 18px; font-weight: bold; text-align: center;">#</div>
                </td>
<td width="250">
    <div style="background: aliceblue; font-size: 18px; font-weight: bold; text-align: center;">Library</div>
</td>
<td width="250">
    <div style="background: aliceblue; font-size: 18px; font-weight: bold; text-align: center;">Licenses</div>
</td>
<td width="250">
    <div style="background: aliceblue; font-size: 18px; font-weight: bold; text-align: center;">Copyrights</div>
</td>
<td width="250">
    <div style="background: aliceblue; font-size: 18px; font-weight: bold; text-align: center;">Notices</div>
</td>
            </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        1
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#1>abab-2.0.6.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>BSD 3</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright © 2019 W3C and Jeff Carpenter \ Both</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        2
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#2>acorn-8.17.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (C) 2012-2022 by various contributors (see AUTHORS)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        3
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#3>acorn-globals-7.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014 Forbes Lindesay</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        4
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#4>acorn-walk-8.3.5.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) by various contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        5
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#5>adler-32-1.2.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Apache 2.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (C) 2014-present SheetJS</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        6
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#6>adler-32-1.3.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Apache 2.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (C) 2014-present SheetJS LLC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        7
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#7>agent-base-6.0.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Nathan Rajlich &lt;nathan@tootallnate.net&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        8
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#8>aix-ppc64-0.28.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Evan Wallace</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        9
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#9>android-arm-0.28.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Evan Wallace</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        10
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#10>android-arm64-0.28.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Evan Wallace</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        11
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#11>android-x64-0.28.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Evan Wallace</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        12
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#12>animations-20.3.25.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2010-2025 Google LLC.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        13
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#13>ansi-escapes-4.3.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (https://sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        14
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#14>ansi-regex-5.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        15
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#15>ansi-styles-4.3.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        16
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#16>ansi-styles-5.2.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        17
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#17>anymatch-3.1.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2019 Elan Shanker, Paul Miller (https://paulmillr.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        18
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#18>applicationinsights-analytics-js-3.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        19
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#19>applicationinsights-channel-js-3.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        20
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#20>applicationinsights-clickanalytics-js-3.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        21
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#21>applicationinsights-common-3.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        22
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#22>applicationinsights-core-js-3.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        23
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#23>applicationinsights-dependencies-js-3.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        24
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#24>applicationinsights-properties-js-3.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        25
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#25>applicationinsights-shims-3.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        26
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#26>applicationinsights-web-3.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        27
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#27>argparse-2.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Python 2.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020 Python Software Foundation; All Rights Reserved</p><p>Copyright (c) 1995-2001 Corporation for National Research Initiatives; All Rights Reserved</p><p>Copyright (c) 1991 - 1995, Stichting Mathematisch Centrum Amsterdam, The Netherlands. All rights reserved.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        28
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#28>asynckit-0.4.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2016 Alex Indigo</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        29
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#29>babel-jest-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        30
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#30>babel-plugin-istanbul-6.1.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>BSD 3</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2016, Istanbul Code Coverage All rights reserved.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        31
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#31>babel-plugin-jest-hoist-29.6.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        32
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#32>babel-preset-current-node-syntax-1.2.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Nicolò Ribaudo and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        33
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#33>babel-preset-jest-29.6.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        34
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#34>babel__core-7.20.5.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        35
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#35>babel__generator-7.27.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        36
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#36>babel__template-7.4.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        37
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#37>babel__traverse-7.28.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        38
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#38>balanced-match-4.0.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Isaac Z. Schlueter &lt;i@izs.me&gt;, Julian Gruber &lt;julian@juliangruber.com&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        39
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#39>base64-js-1.3.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014 Jameson Little</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        40
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#40>baseline-browser-mapping-2.10.38.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Apache 2.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) tonypconway</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        41
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#41>bootstrap-5.3.8.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2011-2025 The Bootstrap Authors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        42
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#42>brace-expansion-5.0.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright Julian Gruber &lt;julian@juliangruber.com&gt;</p><p>Copyright Isaac Z. Schlueter &lt;i@izs.me&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        43
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#43>braces-3.0.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present, Jon Schlinkert.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        44
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#44>brotli-1.3.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Google Inc</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        45
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#45>browserify-zlib-0.2.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-2015 Devon Govett &lt;devongovett@gmail.com&gt;</p><p>Copyright Node.js contributors. All rights reserved.</p><p>Copyright Joyent, Inc. and other Node contributors. All rights reserved.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        46
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#46>browserslist-4.28.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Andrey Sitnik &lt;andrey@sitnik.es&gt; and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        47
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#47>bs-logger-0.2.6.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2018 Huafu Gandon</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        48
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#48>bser-2.1.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Apache 2.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) present Facebook, Inc</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        49
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#49>buffer-from-1.1.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2016, 2018 Linus Unnebäck</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        50
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#50>bufferutil-4.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2011 Einar Otto Stangvik &lt;einaros@gmail.com&gt;</p><p>Copyright (c) 2013 Arnout Kazemier and contributors</p><p>Copyright (c) 2016 Luigi Pinca and contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        51
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#51>call-bind-1.0.9.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Jordan Harband</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        52
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#52>call-bind-apply-helpers-1.0.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2024 Jordan Harband</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        53
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#53>call-bound-1.0.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2024 Jordan Harband</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        54
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#54>callsites-3.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        55
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#55>camelcase-5.3.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        56
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#56>camelcase-6.3.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (https://sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        57
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#57>caniuse-lite-1.0.30001799.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>CC BY 4.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>copyright--then that use is not regulated by the license. Our</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>source is caniuse.com</p>
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        58
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#58>cdk-20.2.14.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2025 Google LLC.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        59
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#59>cfb-1.2.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Apache 2.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (C) 2013-present SheetJS LLC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        60
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#60>chalk-4.1.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        61
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#61>char-regex-1.0.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2019 Richie Bendall</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        62
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#62>chart.js-4.5.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-2024 Chart.js Contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        63
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#63>ci-info-3.9.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2016 Thomas Watson Steen</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        64
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#64>cjs-module-lexer-1.4.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (C) 2018-2020 Guy Bedford</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        65
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#65>clipboard-2.0.11.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Zeno Rocha</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        66
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#66>cliui-8.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2015, Contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        67
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#67>cliui-9.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Blue Oak Model License 1.0.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright Each contributor</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        68
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#68>clone-1.0.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright © 2011-2015 Paul Vorbach &lt;paul@vorba.ch&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        69
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#69>co-4.6.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014 TJ Holowaychuk &amp;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        70
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#70>code-frame-7.29.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        71
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#71>codepage-1.14.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Apache 2.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (C) 2013-present SheetJS</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        72
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#72>collect-v8-coverage-1.0.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2019 Simen Bekkhus</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        73
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#73>color-0.3.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2018-2024 Jukka Kurkela</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        74
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#74>color-convert-2.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2011-2016 Heather Arthur &lt;fayearthur@gmail.com&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        75
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#75>color-name-1.1.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2015 Dmitry Ivanov</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        76
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#76>combined-stream-1.0.8.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2011 Debuggable Limited &lt;felix@debuggable.com&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        77
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#77>commander-2.14.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2011 TJ Holowaychuk &lt;tj@vision-media.ca&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        78
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#78>commander-2.17.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2011 TJ Holowaychuk &lt;tj@vision-media.ca&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        79
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#79>commander-7.2.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2011 TJ Holowaychuk &lt;tj@vision-media.ca&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        80
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#80>commander-8.3.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2011 TJ Holowaychuk &lt;tj@vision-media.ca&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        81
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#81>common-20.3.25.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2010-2025 Google LLC.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        82
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#82>commons-3.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>BSD 3</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2018, Sinon.JS All rights reserved.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        83
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#83>compat-data-7.29.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        84
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#84>compiler-20.3.25.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2010-2025 Google LLC.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        85
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#85>console-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        86
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#86>convert-source-map-2.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2013 Thorsten Lorenz. All rights reserved.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        87
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#87>core-20.3.25.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2010-2025 Google LLC.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        88
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#88>core-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        89
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#89>core-7.29.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        90
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#90>cose-base-1.0.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2019 - present, iVis@Bilkent.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        91
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#91>cose-base-2.2.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2019 - present, iVis@Bilkent.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        92
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#92>crc-32-1.2.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Apache 2.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (C) 2014-present SheetJS LLC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        93
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#93>create-jest-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        94
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#94>cross-spawn-7.0.6.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2018</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        95
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#95>crypto-js-4.2.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2009-2013 Jeff Mott</p><p>Copyright (c) 2013-2016 Evan Vosberg</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        96
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#96>cssom-0.3.8.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Nikita Vasilyev</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        97
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#97>cssom-0.5.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Nikita Vasilyev</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        98
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#98>cssstyle-2.3.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Chad Walker</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        99
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#99>cytoscape-3.34.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2016-2026, The Cytoscape Consortium.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        100
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#100>cytoscape-cose-bilkent-4.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2016-2018, The Cytoscape Consortium.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        101
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#101>cytoscape-fcose-2.2.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2018 - present, iVis-at-Bilkent.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        102
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#102>d-1.0.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2013-2024, Mariusz Nowak, @medikoo, medikoo.com</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        103
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#103>d3-7.4.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        104
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#104>d3-7.9.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2010-2023 Mike Bostock</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        105
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#105>d3-array-2.12.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>BSD 3</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2010-2020 Mike Bostock All rights reserved.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        106
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#106>d3-array-3.2.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        107
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#107>d3-array-3.2.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2010-2023 Mike Bostock</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        108
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#108>d3-axis-3.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2010-2021 Mike Bostock</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        109
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#109>d3-axis-3.0.6.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        110
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#110>d3-brush-3.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2010-2021 Mike Bostock</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        111
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#111>d3-brush-3.0.6.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        112
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#112>d3-chord-3.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2010-2021 Mike Bostock</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        113
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#113>d3-chord-3.0.6.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        114
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#114>d3-color-3.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2010-2022 Mike Bostock</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        115
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#115>d3-color-3.1.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        116
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#116>d3-contour-3.0.6.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        117
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#117>d3-contour-4.0.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2012-2023 Mike Bostock</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        118
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#118>d3-delaunay-6.0.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        119
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#119>d3-delaunay-6.0.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2018-2021 Observable, Inc.</p><p>Copyright 2021 Mapbox</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        120
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#120>d3-dispatch-3.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2010-2021 Mike Bostock</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        121
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#121>d3-dispatch-3.0.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        122
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#122>d3-drag-3.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2010-2021 Mike Bostock</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        123
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#123>d3-drag-3.0.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        124
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#124>d3-dsv-3.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2013-2021 Mike Bostock</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        125
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#125>d3-dsv-3.0.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        126
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#126>d3-ease-3.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>BSD 3</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2010-2021 Mike Bostock</p><p>Copyright 2001 Robert Penner All rights reserved.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        127
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#127>d3-ease-3.0.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        128
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#128>d3-fetch-3.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2016-2021 Mike Bostock</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        129
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#129>d3-fetch-3.0.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        130
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#130>d3-force-3.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2010-2021 Mike Bostock</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        131
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#131>d3-force-3.0.10.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        132
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#132>d3-format-3.0.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        133
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#133>d3-format-3.1.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2010-2026 Mike Bostock</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        134
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#134>d3-geo-3.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        135
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#135>d3-geo-3.1.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2010-2024 Mike Bostock</p><p>Copyright 2008-2012 Charles Karney</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        136
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#136>d3-hierarchy-3.1.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2010-2021 Mike Bostock</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        137
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#137>d3-hierarchy-3.1.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        138
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#138>d3-interpolate-3.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2010-2021 Mike Bostock</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        139
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#139>d3-interpolate-3.0.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        140
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#140>d3-path-1.0.9.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>BSD 3</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2015-2016 Mike Bostock All rights reserved.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        141
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#141>d3-path-3.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2015-2022 Mike Bostock</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        142
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#142>d3-path-3.1.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        143
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#143>d3-polygon-3.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2010-2021 Mike Bostock</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        144
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#144>d3-polygon-3.0.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        145
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#145>d3-quadtree-3.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2010-2021 Mike Bostock</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        146
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#146>d3-quadtree-3.0.6.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        147
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#147>d3-random-3.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2010-2021 Mike Bostock</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        148
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#148>d3-random-3.0.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        149
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#149>d3-sankey-0.12.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>BSD 3</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2015, Mike Bostock All rights reserved.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        150
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#150>d3-scale-4.0.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2010-2021 Mike Bostock</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        151
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#151>d3-scale-4.0.9.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        152
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#152>d3-scale-chromatic-3.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        153
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#153>d3-scale-chromatic-3.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2010-2024 Mike Bostock</p><p>Copyright 2002 Cynthia Brewer, Mark Harrower, and The Pennsylvania State University</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        154
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#154>d3-selection-3.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2010-2021 Mike Bostock</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        155
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#155>d3-selection-3.0.11.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        156
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#156>d3-shape-1.3.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>BSD 3</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2010-2015 Mike Bostock All rights reserved.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        157
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#157>d3-shape-3.1.8.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        158
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#158>d3-shape-3.2.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2010-2022 Mike Bostock</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        159
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#159>d3-time-3.0.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        160
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#160>d3-time-3.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2010-2022 Mike Bostock</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        161
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#161>d3-time-format-4.0.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        162
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#162>d3-time-format-4.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2010-2021 Mike Bostock</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        163
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#163>d3-timer-3.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2010-2021 Mike Bostock</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        164
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#164>d3-timer-3.0.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        165
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#165>d3-transition-3.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2010-2021 Mike Bostock</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        166
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#166>d3-transition-3.0.9.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        167
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#167>d3-zoom-3.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2010-2021 Mike Bostock</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        168
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#168>d3-zoom-3.0.8.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        169
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#169>dagre-d3-es-7.0.14.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2013 Chris Pettitt Original dagre</p><p>Copyright (c) 2012-2014 Chris Pettitt Original graphlib</p><p>Copyright (c) 2012-2014 Chris Pettitt</p><p>Copyright (c) 2022-2024 Thibaut Lassalle, David Newell, Alois Klink, Sidharth Vinod and dagre-es contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        170
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#170>darwin-arm64-0.28.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Evan Wallace</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        171
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#171>darwin-x64-0.28.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Evan Wallace</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        172
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#172>data-urls-3.0.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright © Domenic Denicola &lt;d@domenic.me&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        173
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#173>dayjs-1.11.21.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2018-present, iamkun</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        174
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#174>debug-2.6.9.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014 TJ Holowaychuk &lt;tj@vision-media.ca&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        175
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#175>debug-4.4.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-2017 TJ Holowaychuk &lt;tj@vision-media.ca&gt;</p><p>Copyright (c) 2018-2021 Josh Junon</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        176
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#176>decimal.js-10.6.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2025 Michael Mclaughlin</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        177
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#177>dedent-1.7.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Desmond Brand</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        178
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#178>deep-equal-1.1.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2012, 2013, 2014 James Halliday &lt;mail@substack.net&gt;, 2009 Thomas Robinson</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        179
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#179>deepmerge-4.3.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2012 James Halliday, Josh Duff, and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        180
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#180>define-data-property-1.1.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2023 Jordan Harband</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        181
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#181>define-properties-1.2.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (C) 2015 Jordan Harband</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        182
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#182>delaunator-5.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2026, Mapbox</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        183
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#183>delayed-stream-1.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2011 Debuggable Limited &lt;felix@debuggable.com&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        184
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#184>delegate-3.2.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) zenorocha</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        185
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#185>detect-newline-3.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        186
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#186>dfa-1.2.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Devon Govett</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        187
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#187>diff-sequences-29.6.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        188
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#188>domexception-4.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright © Domenic Denicola</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        189
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#189>dompurify-3.4.11.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Apache-2.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Cure53 and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        190
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#190>dunder-proto-1.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2024 ECMAScript Shims</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        191
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#191>dynamicproto-js-2.0.5.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        192
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#192>electron-to-chromium-1.5.376.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2018 Kilian Valkhof</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        193
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#193>emittery-0.13.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (https://sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        194
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#194>emoji-regex-8.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright Mathias Bynens</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        195
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#195>emoji-toolkit-9.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) My C-Sense, Kuba Werlos, Nikita Popov, Twitter, Inc, Federico Zivolo 2020</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        196
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#196>entities-6.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>BSD 2</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Felix Böhm All rights reserved.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        197
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#197>entities-8.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>BSD 2</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Felix Bohm</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        198
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#198>environment-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        199
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#199>error-ex-1.3.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2015 JD Ballard</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        200
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#200>es-define-property-1.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2024 Jordan Harband</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        201
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#201>es-errors-1.3.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2024 Jordan Harband</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        202
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#202>es-object-atoms-1.1.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2024 Jordan Harband</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        203
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#203>es-set-tostringtag-2.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2022 ECMAScript Shims</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        204
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#204>es-toolkit-1.48.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2024 Viva Republica, Inc.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        205
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#205>es5-ext-0.10.64.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2011-2024, Mariusz Nowak, @medikoo, medikoo.com</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        206
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#206>es5-ext-0.10.64.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2011-2024, Mariusz Nowak, @medikoo, medikoo.com</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        207
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#207>es6-iterator-2.0.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (C) 2013-2017 Mariusz Nowak (www.medikoo.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        208
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#208>es6-symbol-3.1.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2013-2024, Mariusz Nowak, @medikoo, medikoo.com</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        209
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#209>esbuild-0.28.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Evan Wallace</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        210
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#210>esbuild-wasm-0.28.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Evan Wallace</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        211
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#211>escalade-3.2.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Luke Edwards &lt;luke.edwards05@gmail.com&gt; (lukeed.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        212
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#212>escape-string-regexp-2.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        213
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#213>escodegen-2.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>BSD 2</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (C) 2012 Yusuke Suzuki (twitter: @Constellation)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        214
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#214>esniff-2.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2013-2024, Mariusz Nowak, @medikoo, medikoo.com</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        215
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#215>esprima-4.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>BSD 2</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright JS Foundation and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        216
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#216>estraverse-5.3.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>BSD 2</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Yusuke Suzuki &lt;utatane.tea@gmail.com&gt;, Ariya Hidayat &lt;ariya.hidayat@gmail.com&gt;, Yusuke Suzuki (http://github.com/Constellation) (twitter @Constellation (http://twitter.com/Constellation)) and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        217
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#217>esutils-2.0.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>BSD 2</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Ivan Nikulin &lt;ifaaan@gmail.com&gt;, Yusuke Suzuki &lt;utatane.tea@gmail.com&gt;, Yusuke Suzuki (http://github.com/Constellation) (twitter @Constellation (http://twitter.com/Constellation)) and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        218
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#218>event-emitter-0.3.5.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (C) 2012-2015 Mariusz Nowak (www.medikoo.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        219
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#219>execa-5.1.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (https://sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        220
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#220>exit-0.1.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2013 &quot;Cowboy&quot; Ben Alman</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        221
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#221>exit-on-epipe-1.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Apache 2.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (C) 2015-present SheetJS</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        222
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#222>expect-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        223
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#223>expect-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        224
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#224>expect-utils-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        225
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#225>ext-1.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2011-2022, Mariusz Nowak, @medikoo, medikoo.com</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        226
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#226>fake-timers-10.3.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>BSD 3</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2010-2014, Christian Johansen, christian@cjohansen.no. All rights reserved.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        227
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#227>fake-timers-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        228
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#228>fast-json-stable-stringify-2.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2017 Evgeny Poberezkin</p><p>Copyright (c) 2013 James Halliday</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        229
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#229>fb-watchman-2.0.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Apache 2.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        230
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#230>fflate-0.3.11.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Arjun Barrett</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        231
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#231>fill-range-7.1.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present, Jon Schlinkert.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        232
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#232>find-up-4.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        233
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#233>fontkit-1.9.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Devon Govett</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        234
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#234>foreground-child-3.3.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2015-2023 Isaac Z. Schlueter and Contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        235
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#235>form-data-4.0.6.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2012 Felix Geisendörfer (felix@debuggable.com) and contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        236
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#236>forms-20.3.25.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2010-2025 Google LLC.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        237
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#237>frac-1.1.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Apache 2.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (C) 2012-present SheetJS</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        238
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#238>freebsd-arm64-0.28.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Evan Wallace</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        239
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#239>freebsd-x64-0.28.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Evan Wallace</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        240
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#240>fsevents-2.3.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (C) 2010-2020 by Philipp Dunkel, Ben Noordhuis, Elan Shankar, Paul Miller</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        241
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#241>function-bind-1.1.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2013 Raynos.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        242
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#242>functions-have-names-1.2.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2019 Jordan Harband</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        243
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#243>gen-mapping-0.3.13.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2024 Justin Ridgewell &lt;justin@ridgewell.name&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        244
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#244>generate-js-3.1.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-2016 Michaelangelo Jong</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        245
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#245>generator-7.29.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        246
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#246>gensync-1.0.0-beta.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2018 Logan Smyth &lt;loganfsmyth@gmail.com&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        247
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#247>geojson-7946.0.16.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        248
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#248>get-caller-file-2.0.5.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2018 Stefan Penner</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        249
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#249>get-intrinsic-1.3.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Jordan Harband</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        250
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#250>get-package-type-0.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 CFWare, LLC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        251
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#251>get-proto-1.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2025 Jordan Harband</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        252
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#252>get-stream-6.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (https://sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        253
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#253>glob-11.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Blue Oak Model License 1.0.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright Each contributor</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        254
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#254>globals-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        255
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#255>good-listener-1.2.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Zeno Rocha</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        256
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#256>gopd-1.2.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2022 Jordan Harband</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        257
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#257>graceful-fs-4.1.9.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        258
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#258>graceful-fs-4.2.11.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2011-2022 Isaac Z. Schlueter, Ben Noordhuis, and Contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        259
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#259>hachure-fill-0.5.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2023 Preet Shihn</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        260
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#260>handlebars-4.7.9.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) by Yehuda Katz</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        261
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#261>has-flag-4.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        262
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#262>has-property-descriptors-1.0.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2022 Inspect JS</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        263
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#263>has-symbols-1.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2016 Jordan Harband</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        264
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#264>has-tostringtag-1.0.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2021 Inspect JS</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        265
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#265>hasown-2.0.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Jordan Harband and contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        266
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#266>helper-compilation-targets-7.29.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        267
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#267>helper-globals-7.29.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        268
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#268>helper-module-imports-7.29.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        269
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#269>helper-module-transforms-7.29.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        270
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#270>helper-plugin-utils-7.29.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        271
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#271>helper-string-parser-7.29.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        272
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#272>helper-validator-identifier-7.29.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        273
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#273>helper-validator-option-7.29.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        274
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#274>helpers-7.29.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p><p>Copyright (c) 2014-present, Facebook, Inc. (ONLY ./src/helpers/regenerator files)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        275
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#275>html-encoding-sniffer-3.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright © Domenic Denicola &lt;d@domenic.me&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        276
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#276>html-escaper-2.0.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (C) 2017-present by Andrea Giammarchi - @WebReflection</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        277
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#277>html-to-pdfmake-2.5.33.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2019 Aymeric</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        278
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#278>http-proxy-agent-5.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Nathan Rajlich &lt;nathan@tootallnate.net&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        279
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#279>https-proxy-agent-5.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Nathan Rajlich &lt;nathan@tootallnate.net&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        280
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#280>human-signals-2.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Apache 2.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2019 ehmicky &lt;ehmicky@gmail.com&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        281
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#281>iconv-lite-0.6.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2011 Alexander Shtuchkin</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        282
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#282>iconv-lite-0.7.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2011 Alexander Shtuchkin</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        283
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#283>import-local-3.2.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (https://sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        284
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#284>import-meta-resolve-4.2.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Titus Wormer</p><p>Copyright Node.js contributors. All rights reserved.</p><p>Copyright Joyent, Inc. and other Node contributors. All rights reserved.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        285
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#285>imurmurhash-0.1.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Gary Court, Jens Taylor</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        286
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#286>install-pkg-1.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2021 Anthony Fu</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        287
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#287>internmap-1.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2021 Mike Bostock</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        288
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#288>internmap-2.0.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2021 Mike Bostock</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        289
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#289>is-arguments-1.2.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014 Jordan Harband</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        290
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#290>is-arrayish-0.2.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2015 JD Ballard</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        291
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#291>is-core-module-2.16.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014 Dave Justice</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        292
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#292>is-date-object-1.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2015 Jordan Harband</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        293
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#293>is-fullwidth-code-point-3.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        294
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#294>is-generator-fn-2.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        295
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#295>is-number-7.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present, Jon Schlinkert.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        296
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#296>is-potential-custom-element-name-1.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright Mathias Bynens</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        297
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#297>is-regex-1.2.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014 Jordan Harband</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        298
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#298>is-stream-2.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (https://sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        299
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#299>is-typedarray-1.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Hugh Kennedy</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        300
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#300>isexe-2.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Isaac Z. Schlueter and Contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        301
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#301>istanbul-lib-coverage-2.0.6.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        302
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#302>istanbul-lib-coverage-3.2.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>BSD 3</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2012-2015 Yahoo! Inc. All rights reserved.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        303
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#303>istanbul-lib-instrument-5.2.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>BSD 3</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2012-2015 Yahoo! Inc. All rights reserved.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        304
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#304>istanbul-lib-instrument-6.0.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>BSD 3</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2012-2015 Yahoo! Inc. All rights reserved.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        305
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#305>istanbul-lib-report-3.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>BSD 3</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2012-2015 Yahoo! Inc. All rights reserved.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        306
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#306>istanbul-lib-report-3.0.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        307
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#307>istanbul-lib-source-maps-4.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>BSD 3</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2015 Yahoo! Inc. All rights reserved.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        308
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#308>istanbul-reports-3.0.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        309
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#309>istanbul-reports-3.2.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>BSD 3</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2012-2015 Yahoo! Inc. All rights reserved.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        310
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#310>jackspeak-4.2.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Blue Oak Model License 1.0.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright Each contributor</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        311
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#311>jest-29.5.14.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        312
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#312>jest-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        313
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#313>jest-changed-files-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        314
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#314>jest-circus-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        315
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#315>jest-cli-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        316
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#316>jest-config-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        317
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#317>jest-diff-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        318
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#318>jest-docblock-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        319
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#319>jest-each-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        320
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#320>jest-environment-jsdom-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        321
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#321>jest-environment-node-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        322
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#322>jest-get-type-29.6.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        323
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#323>jest-haste-map-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        324
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#324>jest-leak-detector-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        325
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#325>jest-matcher-utils-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        326
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#326>jest-message-util-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        327
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#327>jest-mock-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        328
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#328>jest-pnp-resolver-1.2.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Mael Nison</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        329
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#329>jest-preset-angular-14.6.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2017 Michał Pierzchała</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        330
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#330>jest-regex-util-29.6.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        331
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#331>jest-resolve-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        332
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#332>jest-resolve-dependencies-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        333
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#333>jest-runner-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        334
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#334>jest-runtime-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        335
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#335>jest-snapshot-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        336
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#336>jest-util-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        337
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#337>jest-validate-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        338
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#338>jest-watcher-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        339
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#339>jest-worker-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        340
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#340>jpeg-exif-1.1.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2015 邵振华</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        341
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#341>js-tokens-4.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014, 2015, 2016, 2017, 2018 Simon Lydell</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        342
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#342>js-yaml-4.3.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (C) 2011-2015 by Vitaly Puzrin</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        343
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#343>jsdom-20.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        344
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#344>jsdom-20.0.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2010 Elijah Insua</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        345
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#345>jsesc-3.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright Mathias Bynens</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        346
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#346>json-parse-even-better-errors-2.3.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2017 Kat Marchán</p><p>Copyright npm, Inc.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        347
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#347>json5-2.2.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2012-2018 Aseem Kishore, and [others]</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        348
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#348>jwt-decode-4.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2015 Auth0, Inc. &lt;support@auth0.com&gt; (http://auth0.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        349
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#349>katex-0.16.47.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2013-2020 Khan Academy and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        350
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#350>khroma-2.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2019-present Fabio Spampinato, Andrew Maney</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        351
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#351>kleur-3.0.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Luke Edwards &lt;luke.edwards05@gmail.com&gt; (lukeed.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        352
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#352>layout-base-1.0.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2019 iVis@Bilkent</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        353
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#353>layout-base-2.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2019 iVis@Bilkent</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        354
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#354>leven-3.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        355
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#355>linebreak-1.1.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Devon Govett</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        356
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#356>lines-and-columns-1.2.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2015 Brian Donovan</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        357
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#357>linux-arm-0.28.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Evan Wallace</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        358
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#358>linux-arm64-0.28.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Evan Wallace</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        359
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#359>linux-ia32-0.28.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Evan Wallace</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        360
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#360>linux-loong64-0.28.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Evan Wallace</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        361
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#361>linux-mips64el-0.28.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Evan Wallace</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        362
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#362>linux-ppc64-0.28.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Evan Wallace</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        363
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#363>linux-riscv64-0.28.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Evan Wallace</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        364
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#364>linux-s390x-0.28.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Evan Wallace</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        365
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#365>linux-x64-0.28.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Evan Wallace</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        366
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#366>load-nyc-config-1.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2019, Contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        367
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#367>locate-path-5.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        368
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#368>lodash-es-4.18.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright OpenJS Foundation and other contributors</p><p>copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters &amp; Editors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        369
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#369>lodash.memoize-4.1.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright jQuery Foundation and other contributors</p><p>copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters &amp; Editors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        370
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#370>lru-cache-11.5.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Blue Oak Model License 1.0.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright Each contributor</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        371
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#371>lru-cache-5.1.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Isaac Z. Schlueter and Contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        372
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#372>make-dir-4.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (https://sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        373
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#373>make-error-1.3.6.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2014 Julien Fontanet</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        374
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#374>makeerror-1.0.12.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>BSD 3</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014, Naitik Shah. All rights reserved.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        375
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#375>marked-16.4.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2018+, MarkedJS (https://github.com/markedjs/)</p><p>Copyright (c) 2011-2018, Christopher Jeffrey (https://github.com/chjj/)</p><p>Copyright © 2004, John Gruber</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        376
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#376>material-20.2.14.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2025 Google LLC.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        377
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#377>math-intrinsics-1.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2024 ECMAScript Shims</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        378
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#378>merge-stream-2.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Stephen Sugden &lt;me@stephensugden.com&gt; (stephensugden.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        379
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#379>mermaid-11.15.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Koen Bok, Gaetan Renaudeau, Cure53 and other contributors, Knut Sveidqvist, The Cytoscape Consortium</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        380
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#380>micromatch-4.0.8.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present, Jon Schlinkert.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        381
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#381>mime-db-1.52.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014 Jonathan Ong &lt;me@jongleberry.com&gt;</p><p>Copyright (c) 2015-2022 Douglas Christopher Wilson &lt;doug@somethingdoug.com&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        382
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#382>mime-types-2.1.35.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014 Jonathan Ong &lt;me@jongleberry.com&gt;</p><p>Copyright (c) 2015 Douglas Christopher Wilson &lt;doug@somethingdoug.com&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        383
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#383>mimic-fn-2.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        384
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#384>minimatch-10.2.5.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Blue Oak Model License 1.0.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>copyright in it</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        385
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#385>minimist-1.2.8.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2013 James Halliday and contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        386
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#386>minipass-7.1.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Blue Oak Model License 1.0.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright Each contributor</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        387
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#387>ms-2.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2016 Zeit, Inc.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        388
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#388>ms-2.1.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Vercel, Inc.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        389
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#389>msal-angular-3.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation. All rights reserved.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        390
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#390>msal-browser-3.30.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation. All rights reserved.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        391
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#391>msal-common-14.16.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation. All rights reserved.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        392
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#392>natural-compare-1.4.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Lauri Rooden &lt;lauri@rooden.ee&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        393
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#393>neo-async-2.6.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-2018 Suguru Motegi</p><p>Copyright Caolan McMahon</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        394
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#394>netbsd-arm64-0.28.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Evan Wallace</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        395
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#395>netbsd-x64-0.28.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Evan Wallace</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        396
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#396>next-tick-1.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2012-2020, Mariusz Nowak, @medikoo, medikoo.com</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        397
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#397>ngx-file-drop-16.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2017 georgipeltekov</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        398
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#398>ngx-markdown-20.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2017-2025 Jean-Francois Cere</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        399
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#399>node-20.19.43.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        400
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#400>node-gyp-build-4.8.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2017 Mathias Buus</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        401
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#401>node-int64-0.4.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014 Robert Kieffer</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        402
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#402>node-releases-2.0.48.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2017 Sergey Rubanov (https://github.com/chicoxyzzy)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        403
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#403>normalize-path-3.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-2018, Jon Schlinkert.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        404
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#404>npm-run-path-4.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        405
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#405>nwsapi-2.2.24.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2007-2026 Diego Perini (http://www.iport.it/)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        406
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#406>object-is-1.1.6.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014 Jordan Harband</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        407
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#407>object-keys-1.1.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (C) 2013 Jordan Harband</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        408
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#408>once-3.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Nathan Rajlich</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        409
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#409>onetime-5.1.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (https://sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        410
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#410>openbsd-arm64-0.28.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Evan Wallace</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        411
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#411>openbsd-x64-0.28.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Evan Wallace</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        412
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#412>openharmony-arm64-0.28.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) The Go Authors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        413
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#413>p-limit-2.3.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        414
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#414>p-limit-3.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (https://sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        415
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#415>p-locate-4.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        416
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#416>p-try-2.2.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        417
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#417>package-json-from-dist-1.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Blue Oak Model License 1.0.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright Each contributor</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        418
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#418>package-manager-detector-1.6.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020-PRESENT Anthony Fu</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        419
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#419>pako-0.2.9.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (C) 2014-2016 by Vitaly Puzrin</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        420
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#420>pako-1.0.11.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (C) 2014-2017 by Vitaly Puzrin and Andrei Tuputcyn</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        421
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#421>parse-json-5.2.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (https://sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        422
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#422>parse5-7.3.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2013-2019 Ivan Nikulin (ifaaan@gmail.com</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        423
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#423>parse5-8.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Ivan Nikulin (ifaaan@gmail.com, https://github.com/inikulin)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        424
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#424>parser-1.1.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Y. Daveluy, TypeFox GmbH, Yokozuna59, Microsoft Corporation, TypeFox, Microsoft and others</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        425
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#425>parser-7.29.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (C) 2012-2014 by various contributors (see AUTHORS)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        426
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#426>path-data-parser-0.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Preet Shihn</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        427
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#427>path-exists-4.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        428
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#428>path-key-3.1.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        429
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#429>path-parse-1.0.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2015 Javier Blanco</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        430
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#430>path-scurry-2.0.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Blue Oak Model License 1.0.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>copyright in it</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        431
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#431>pdfkit-0.15.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014 Devon Govett</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        432
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#432>pdfmake-0.2.23.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-2015 bpampuch 2016-2026 liborm85</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        433
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#433>picocolors-1.1.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2021-2024 Oleksii Raspopov, Kostiantyn Denysov, Anton Verinov</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        434
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#434>picomatch-4.0.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) present, Jon Schlinkert, present, Jon Schlinkert (https://github.com/jonschlinkert)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        435
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#435>pirates-4.0.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2016-2018 Ari Porad</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        436
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#436>pkg-dir-4.2.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        437
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#437>platform-browser-20.3.25.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2010-2025 Google LLC.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        438
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#438>platform-browser-dynamic-20.3.25.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2010-2025 Google LLC.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        439
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#439>plugin-syntax-async-generators-7.8.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        440
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#440>plugin-syntax-bigint-7.8.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        441
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#441>plugin-syntax-class-properties-7.12.13.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        442
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#442>plugin-syntax-class-static-block-7.14.5.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        443
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#443>plugin-syntax-import-attributes-7.29.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        444
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#444>plugin-syntax-import-meta-7.10.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        445
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#445>plugin-syntax-json-strings-7.8.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        446
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#446>plugin-syntax-jsx-7.29.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        447
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#447>plugin-syntax-logical-assignment-operators-7.10.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        448
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#448>plugin-syntax-nullish-coalescing-operator-7.8.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        449
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#449>plugin-syntax-numeric-separator-7.10.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        450
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#450>plugin-syntax-object-rest-spread-7.8.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        451
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#451>plugin-syntax-optional-catch-binding-7.8.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        452
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#452>plugin-syntax-optional-chaining-7.8.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        453
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#453>plugin-syntax-private-property-in-object-7.14.5.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        454
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#454>plugin-syntax-top-level-await-7.14.5.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        455
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#455>plugin-syntax-typescript-7.29.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        456
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#456>png-js-1.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2017 Devon Govett</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        457
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#457>points-on-curve-0.2.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Preet Shihn</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        458
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#458>points-on-path-0.2.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Preet</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        459
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#459>pretty-format-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        460
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#460>printj-1.1.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Apache 2.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (C) 2016-present SheetJS</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        461
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#461>prismjs-1.30.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2012 Lea Verou</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        462
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#462>prompts-2.4.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2018 Terkel Gjervig Nielsen</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        463
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#463>psl-1.15.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2017 Lupo Montero lupomontero@gmail.com</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        464
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#464>punycode-2.3.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright Mathias Bynens</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        465
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#465>pure-rand-6.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2018 Nicolas DUBIEN</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        466
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#466>querystringify-2.2.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2015 Unshift.io, Arnout Kazemier, the Contributors.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        467
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#467>react-is-18.3.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Facebook, Inc. and its affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        468
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#468>regexp.prototype.flags-1.5.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (C) 2014 Jordan Harband</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        469
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#469>remapping-2.3.5.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2024 Justin Ridgewell &lt;justin@ridgewell.name&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        470
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#470>reporters-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        471
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#471>require-directory-2.1.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2011 Troy Goode &lt;troygoode@gmail.com&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        472
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#472>requires-port-1.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2015 Unshift.io, Arnout Kazemier, the Contributors.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        473
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#473>resolve-1.22.10.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2012 James Halliday</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        474
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#474>resolve-cwd-3.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        475
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#475>resolve-from-5.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        476
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#476>resolve-uri-3.1.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2019 Justin Ridgewell &lt;jridgewell@google.com&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        477
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#477>resolve.exports-2.0.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Luke Edwards &lt;luke.edwards05@gmail.com&gt; (lukeed.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        478
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#478>restructure-2.0.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2015-present Devon Govett</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        479
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#479>robust-predicates-3.0.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Unlicense</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Vladimir Agafonkin</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        480
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#480>roughjs-4.6.6.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2019 Preet Shihn</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        481
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#481>router-20.3.25.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2010-2025 Google LLC.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        482
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#482>rw-1.3.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>BSD 3</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-2016, Michael Bostock All rights reserved.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        483
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#483>rxjs-7.8.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Apache 2.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2015-2018 Google, Inc., Netflix, Inc., Microsoft Corp. and contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        484
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#484>safer-buffer-2.1.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2018 Nikita Skovoroda &lt;chalkerx@gmail.com&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        485
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#485>sanitize-url-7.1.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2017 Braintree</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        486
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#486>sax-1.6.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Blue Oak Model License 1.0.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>copyright in it</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        487
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#487>saxes-6.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Contributors</p><p>Copyright (c) Isaac Z. Schlueter and Contributors</p><p>Copyright Mathias Bynens &lt;https://mathiasbynens.be/&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        488
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#488>schema-0.1.6.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) CFWare, LLC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        489
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#489>schemas-29.6.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        490
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#490>secure-web-storage-1.0.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2017 Michaelangelo Jong</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        491
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#491>select-1.1.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Zeno Rocha</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        492
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#492>semver-6.3.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Isaac Z. Schlueter and Contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        493
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#493>semver-7.7.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Isaac Z. Schlueter and Contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        494
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#494>semver-7.8.5.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Isaac Z. Schlueter and Contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        495
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#495>set-function-length-1.2.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Jordan Harband and contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        496
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#496>set-function-name-2.0.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Jordan Harband and contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        497
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#497>shebang-command-2.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Kevin Mårtensson &lt;kevinmartensson@gmail.com&gt; (github.com/kevva)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        498
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#498>shebang-regex-3.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        499
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#499>signal-exit-3.0.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2015, Contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        500
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#500>signal-exit-4.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2015-2023 Benjamin Coe, Isaac Z. Schlueter, and Contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        501
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#501>sisteransi-1.0.5.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2018 Terkel Gjervig Nielsen</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        502
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#502>slash-3.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        503
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#503>source-map-0.6.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>BSD 3</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2009-2011, Mozilla Foundation and contributors All rights reserved.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        504
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#504>source-map-29.6.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        505
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#505>source-map-support-0.5.13.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014 Evan Wallace</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        506
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#506>sourcemap-codec-1.5.5.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2024 Justin Ridgewell &lt;justin@ridgewell.name&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        507
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#507>ssf-0.11.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Apache 2.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (C) 2013-present SheetJS LLC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        508
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#508>stack-utils-2.0.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        509
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#509>stack-utils-2.0.6.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2016-2022 Isaac Z. Schlueter , James Talmage (github.com/jamestalmage),</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        510
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#510>string-length-4.0.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (https://sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        511
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#511>string-width-4.2.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        512
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#512>strip-ansi-6.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        513
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#513>strip-bom-4.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        514
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#514>strip-final-newline-2.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        515
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#515>strip-json-comments-3.1.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (https://sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        516
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#516>stylis-4.4.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2016-present Sultan Tarimo</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        517
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#517>sunos-x64-0.28.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Evan Wallace</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        518
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#518>supports-color-7.2.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        519
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#519>supports-color-8.1.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (https://sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        520
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#520>supports-preserve-symlinks-flag-1.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2022 Inspect JS</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        521
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#521>symbol-tree-3.2.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2015 Joris van der Wel</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        522
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#522>template-7.29.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        523
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#523>test-exclude-6.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2016, Contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        524
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#524>test-result-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        525
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#525>test-sequencer-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        526
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#526>tiny-emitter-2.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2017 Scott Corgan</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        527
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#527>tiny-inflate-1.0.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2015-present Devon Govett</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        528
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#528>tinyexec-1.2.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2024 Tinylibs</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        529
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#529>tldts-7.4.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2017 Thomas Parisot, 2018 Rémi Berson</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        530
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#530>tldts-core-7.4.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2017 Thomas Parisot, 2018 Rémi Berson</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        531
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#531>tmpl-1.0.5.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>BSD 3</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014, Naitik Shah. All rights reserved.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        532
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#532>to-regex-range-5.0.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2015-present, Jon Schlinkert.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        533
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#533>tough-cookie-4.0.5.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        534
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#534>tough-cookie-4.1.4.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>BSD 3</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2015, Salesforce.com, Inc. All rights reserved.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        535
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#535>tr46-3.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sebastian Mayr</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        536
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#536>trace-mapping-0.3.31.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2024 Justin Ridgewell &lt;justin@ridgewell.name&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        537
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#537>transform-29.7.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        538
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#538>traverse-7.29.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        539
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#539>trusted-types-2.0.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        540
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#540>ts-async-0.6.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2022 NevWare21 Solutions LLC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        541
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#541>ts-dedent-2.3.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2018 Tamino Martinius</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        542
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#542>ts-jest-29.4.11.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2016-2025</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        543
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#543>ts-utils-0.15.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2022 NevWare21 Solutions LLC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        544
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#544>tslib-2.8.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>BSD Zero</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        545
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#545>type-2.7.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2019-2024, Mariusz Nowak, @medikoo, medikoo.com</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        546
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#546>type-detect-4.0.8.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2013 Jake Luer &lt;jake@alogicalparadox.com&gt; (http://alogicalparadox.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        547
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#547>type-fest-0.21.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>CC0-1.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (https:/sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        548
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#548>type-fest-4.41.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>CC0-1.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        549
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#549>typebox-0.27.10.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2017-2023 Haydn Paterson (sinclair)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        550
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#550>typedarray-to-buffer-3.1.5.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Feross Aboukhadijeh</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        551
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#551>types-11.1.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Apache 2.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2021 the original author or authors from the Chevrotain project</p><p>Copyright (c) 2015-2020 SAP SE or an SAP affiliate company</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        552
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#552>types-2.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2021 - 2022 Vjacheslav Trushkin / Iconify OÜ</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        553
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#553>types-29.6.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Meta Platforms, Inc. and affiliates.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        554
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#554>types-7.29.7.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014-present Sebastian McKenzie and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        555
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#555>uglify-js-3.19.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>BSD 2</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2012-2024 (c) Mihai Bazon &lt;mihai.bazon@gmail.com&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        556
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#556>undici-types-6.21.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Matteo Collina and Undici contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        557
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#557>unicode-properties-1.4.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2018</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        558
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#558>unicode-trie-2.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2018</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        559
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#559>universalify-0.2.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2017, Ryan Zimmerman &lt;opensrc@ryanzim.com&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        560
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#560>update-browserslist-db-1.2.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2022 Andrey Sitnik &lt;andrey@sitnik.ru&gt; and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        561
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#561>url-parse-1.5.10.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2015 Unshift.io, Arnout Kazemier, the Contributors.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        562
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#562>utf-8-validate-5.0.10.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2011 Einar Otto Stangvik &lt;einaros@gmail.com&gt; (http://2x.io)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        563
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#563>utils-3.1.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Vjacheslav Trushkin</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        564
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#564>uuid-11.1.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2010-2020 Robert Kieffer and other contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        565
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#565>v8-coverage-0.2.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright © 2015-2017 Charles Samborski</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        566
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#566>v8-to-istanbul-9.3.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2017, Contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        567
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#567>venn.js-2.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2013 Ben Frederickson</p><p>Copyright (c) 2021 Samuel Gratzl</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        568
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#568>w3c-xmlserializer-4.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright © Sebastian Mayr</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        569
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#569>walker-1.0.8.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Apache 2.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2013 Naitik Shah</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        570
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#570>webidl-conversions-7.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>BSD 2</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2014, Domenic Denicola All rights reserved.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        571
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#571>websocket-1.0.35.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Apache 2.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Brian McKelvey, Iñaki Baz Castillo</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        572
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#572>whatwg-encoding-2.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright © Domenic Denicola &lt;d@domenic.me&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        573
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#573>whatwg-mimetype-3.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright © Domenic Denicola &lt;d@domenic.me&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        574
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#574>whatwg-url-11.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sebastian Mayr</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        575
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#575>which-2.0.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Isaac Z. Schlueter and Contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        576
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#576>win32-arm64-0.28.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Evan Wallace</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        577
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#577>win32-ia32-0.28.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Evan Wallace</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        578
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#578>win32-x64-0.28.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2020 Evan Wallace</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        579
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#579>wmf-1.0.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Apache 2.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (C) 2020-present SheetJS LLC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        580
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#580>word-0.3.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Apache 2.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (C) 2020-present SheetJS LLC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        581
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#581>wordwrap-1.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) James Halliday</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        582
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#582>wrap-ansi-7.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (https://sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        583
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#583>write-file-atomic-4.0.2.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2015, Rebecca Turner</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        584
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#584>ws-8.21.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2011 Einar Otto Stangvik &lt;einaros@gmail.com&gt;</p><p>Copyright (c) 2013 Arnout Kazemier and contributors</p><p>Copyright (c) 2016 Luigi Pinca and contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        585
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#585>xlsx-0.20.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Apache 2.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (C) 2012-present SheetJS LLC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        586
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#586>xlsx-js-style-1.2.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Apache 2.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (C) 2012-present SheetJS LLC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        587
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#587>xml-name-validator-4.0.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Apache 2.0</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Domenic Denicola</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        588
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#588>xmlchars-2.2.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright Louis-Dominique Dubeau and contributors to xmlchars</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        589
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#589>xmldoc-2.0.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2012 Nick Farina. All rights reserved.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        590
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#590>y18n-5.0.8.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2015, Contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        591
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#591>yaeti-0.0.6.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2015 Iñaki Baz Castillo, &lt;ibc@aliax.net&gt;</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        592
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#592>yallist-3.1.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Isaac Z. Schlueter and Contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        593
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#593>yargs-17.0.35.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        594
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#594>yargs-17.7.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright 2010 James Halliday (mail@substack.net)</p><p>Copyright 2014 Contributors (ben@npmjs.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        595
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#595>yargs-parser-21.0.3.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Microsoft Corporation.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        596
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#596>yargs-parser-21.1.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>ISC</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2016, Contributors</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        597
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#597>yocto-queue-0.1.0.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (https://sindresorhus.com)</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
                <tr>
                    <td width="50" style="text-align: center">
                        598
                    </td>
                    <td width="250" style="text-align: center">
                            <a href=#598>zone.js-0.15.1.tgz</a>
                    </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>MIT</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    <p>Copyright (c) 2010-2025 Google LLC.</p>
                            </div>
                        </td>
                        <td width="250" style="text-align: center">
                            <div>
                                    
                            </div>
                        </td>
                </tr>
            </tbody>
        </table>
        <div style="padding-top: 35px;"/>
            <br/><br/>
            <div style="border-bottom: 2px solid #616161; box-shadow: 0 1px 1px #ccc;">
                <div style="font-size: 32px; text-align: left;">APPENDIX</div>
            </div>
            <div style="padding: 30px 0px 0px 21px; display: block; font-size: 1.12em; font-weight: bold;">
                Licenses
            </div>
            <br/>
                <div style="padding: 10px 0px 0px 21px; font-weight: bold;" id=L1>1. BSD 3</div>
                <div style="padding: 10px 0px 0px 21px; white-space: pre-wrap;">License Text:
Copyright (c) &lt;year&gt; &lt;owner&gt;. 

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

1. Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.

2. Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

3. Neither the name of the copyright holder nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS &quot;AS IS&quot; AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

</div>
                <br/>
                <div style="padding: 10px 0px 0px 21px; font-weight: bold;" id=L2>2. MIT</div>
                <div style="padding: 10px 0px 0px 21px; white-space: pre-wrap;">License Text:
MIT License

Copyright (c) &lt;year&gt; &lt;copyright holders&gt;

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
associated documentation files (the &quot;Software&quot;), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the
following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial
portions of the Software.

THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT
LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO
EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
USE OR OTHER DEALINGS IN THE SOFTWARE.

</div>
                <br/>
                <div style="padding: 10px 0px 0px 21px; font-weight: bold;" id=L3>3. Apache 2.0</div>
                <div style="padding: 10px 0px 0px 21px; white-space: pre-wrap;">License Text:
Apache License
Version 2.0, January 2004
http://www.apache.org/licenses/

TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION

1. Definitions.

&quot;License&quot; shall mean the terms and conditions for use, reproduction, and distribution as defined by Sections 1 through 9 of this document.

&quot;Licensor&quot; shall mean the copyright owner or entity authorized by the copyright owner that is granting the License.

&quot;Legal Entity&quot; shall mean the union of the acting entity and all other entities that control, are controlled by, or are under common control with that entity. For the purposes of this definition, &quot;control&quot; means (i) the power, direct or indirect, to cause the direction or management of such entity, whether by contract or otherwise, or (ii) ownership of fifty percent (50%) or more of the outstanding shares, or (iii) beneficial ownership of such entity.

&quot;You&quot; (or &quot;Your&quot;) shall mean an individual or Legal Entity exercising permissions granted by this License.

&quot;Source&quot; form shall mean the preferred form for making modifications, including but not limited to software source code, documentation source, and configuration files.

&quot;Object&quot; form shall mean any form resulting from mechanical transformation or translation of a Source form, including but not limited to compiled object code, generated documentation, and conversions to other media types.

&quot;Work&quot; shall mean the work of authorship, whether in Source or Object form, made available under the License, as indicated by a copyright notice that is included in or attached to the work (an example is provided in the Appendix below).

&quot;Derivative Works&quot; shall mean any work, whether in Source or Object form, that is based on (or derived from) the Work and for which the editorial revisions, annotations, elaborations, or other modifications represent, as a whole, an original work of authorship. For the purposes of this License, Derivative Works shall not include works that remain separable from, or merely link (or bind by name) to the interfaces of, the Work and Derivative Works thereof.

&quot;Contribution&quot; shall mean any work of authorship, including the original version of the Work and any modifications or additions to that Work or Derivative Works thereof, that is intentionally submitted to Licensor for inclusion in the Work by the copyright owner or by an individual or Legal Entity authorized to submit on behalf of the copyright owner. For the purposes of this definition, &quot;submitted&quot; means any form of electronic, verbal, or written communication sent to the Licensor or its representatives, including but not limited to communication on electronic mailing lists, source code control systems, and issue tracking systems that are managed by, or on behalf of, the Licensor for the purpose of discussing and improving the Work, but excluding communication that is conspicuously marked or otherwise designated in writing by the copyright owner as &quot;Not a Contribution.&quot;

&quot;Contributor&quot; shall mean Licensor and any individual or Legal Entity on behalf of whom a Contribution has been received by Licensor and subsequently incorporated within the Work.

2. Grant of Copyright License. Subject to the terms and conditions of this License, each Contributor hereby grants to You a perpetual, worldwide, non-exclusive, no-charge, royalty-free, irrevocable copyright license to reproduce, prepare Derivative Works of, publicly display, publicly perform, sublicense, and distribute the Work and such Derivative Works in Source or Object form.

3. Grant of Patent License. Subject to the terms and conditions of this License, each Contributor hereby grants to You a perpetual, worldwide, non-exclusive, no-charge, royalty-free, irrevocable (except as stated in this section) patent license to make, have made, use, offer to sell, sell, import, and otherwise transfer the Work, where such license applies only to those patent claims licensable by such Contributor that are necessarily infringed by their Contribution(s) alone or by combination of their Contribution(s) with the Work to which such Contribution(s) was submitted. If You institute patent litigation against any entity (including a cross-claim or counterclaim in a lawsuit) alleging that the Work or a Contribution incorporated within the Work constitutes direct or contributory patent infringement, then any patent licenses granted to You under this License for that Work shall terminate as of the date such litigation is filed.

4. Redistribution. You may reproduce and distribute copies of the Work or Derivative Works thereof in any medium, with or without modifications, and in Source or Object form, provided that You meet the following conditions:

     (a) You must give any other recipients of the Work or Derivative Works a copy of this License; and

     (b) You must cause any modified files to carry prominent notices stating that You changed the files; and

     (c) You must retain, in the Source form of any Derivative Works that You distribute, all copyright, patent, trademark, and attribution notices from the Source form of the Work, excluding those notices that do not pertain to any part of the Derivative Works; and

     (d) If the Work includes a &quot;NOTICE&quot; text file as part of its distribution, then any Derivative Works that You distribute must include a readable copy of the attribution notices contained within such NOTICE file, excluding those notices that do not pertain to any part of the Derivative Works, in at least one of the following places: within a NOTICE text file distributed as part of the Derivative Works; within the Source form or documentation, if provided along with the Derivative Works; or, within a display generated by the Derivative Works, if and wherever such third-party notices normally appear. The contents of the NOTICE file are for informational purposes only and do not modify the License. You may add Your own attribution notices within Derivative Works that You distribute, alongside or as an addendum to the NOTICE text from the Work, provided that such additional attribution notices cannot be construed as modifying the License.

     You may add Your own copyright statement to Your modifications and may provide additional or different license terms and conditions for use, reproduction, or distribution of Your modifications, or for any such Derivative Works as a whole, provided Your use, reproduction, and distribution of the Work otherwise complies with the conditions stated in this License.

5. Submission of Contributions. Unless You explicitly state otherwise, any Contribution intentionally submitted for inclusion in the Work by You to the Licensor shall be under the terms and conditions of this License, without any additional terms or conditions. Notwithstanding the above, nothing herein shall supersede or modify the terms of any separate license agreement you may have executed with Licensor regarding such Contributions.

6. Trademarks. This License does not grant permission to use the trade names, trademarks, service marks, or product names of the Licensor, except as required for reasonable and customary use in describing the origin of the Work and reproducing the content of the NOTICE file.

7. Disclaimer of Warranty. Unless required by applicable law or agreed to in writing, Licensor provides the Work (and each Contributor provides its Contributions) on an &quot;AS IS&quot; BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied, including, without limitation, any warranties or conditions of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A PARTICULAR PURPOSE. You are solely responsible for determining the appropriateness of using or redistributing the Work and assume any risks associated with Your exercise of permissions under this License.

8. Limitation of Liability. In no event and under no legal theory, whether in tort (including negligence), contract, or otherwise, unless required by applicable law (such as deliberate and grossly negligent acts) or agreed to in writing, shall any Contributor be liable to You for damages, including any direct, indirect, special, incidental, or consequential damages of any character arising as a result of this License or out of the use or inability to use the Work (including but not limited to damages for loss of goodwill, work stoppage, computer failure or malfunction, or any and all other commercial damages or losses), even if such Contributor has been advised of the possibility of such damages.

9. Accepting Warranty or Additional Liability. While redistributing the Work or Derivative Works thereof, You may choose to offer, and charge a fee for, acceptance of support, warranty, indemnity, or other liability obligations and/or rights consistent with this License. However, in accepting such obligations, You may act only on Your own behalf and on Your sole responsibility, not on behalf of any other Contributor, and only if You agree to indemnify, defend, and hold each Contributor harmless for any liability incurred by, or claims asserted against, such Contributor by reason of your accepting any such warranty or additional liability.

END OF TERMS AND CONDITIONS

APPENDIX: How to apply the Apache License to your work.

To apply the Apache License to your work, attach the following boilerplate notice, with the fields enclosed by brackets &quot;[]&quot; replaced with your own identifying information. (Don&#x27;t include the brackets!)  The text should be enclosed in the appropriate comment syntax for the file format. We also recommend that a file or class name and description of purpose be included on the same &quot;printed page&quot; as the copyright notice for easier identification within third-party archives.

Copyright [yyyy] [name of copyright owner]

Licensed under the Apache License, Version 2.0 (the &quot;License&quot;);
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an &quot;AS IS&quot; BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

</div>
                <br/>
                <div style="padding: 10px 0px 0px 21px; font-weight: bold;" id=L4>4. ISC</div>
                <div style="padding: 10px 0px 0px 21px; white-space: pre-wrap;">License Text:
ISC License:

Copyright (c) 2004-2010 by Internet Systems Consortium, Inc. (&quot;ISC&quot;)
Copyright (c) 1995-2003 by Internet Software Consortium

Permission to use, copy, modify, and/or distribute this software for any purpose with or without fee is hereby granted, provided that the above copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED &quot;AS IS&quot; AND ISC DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL ISC BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.

</div>
                <br/>
                <div style="padding: 10px 0px 0px 21px; font-weight: bold;" id=L5>5. Python 2.0</div>
                <div style="padding: 10px 0px 0px 21px; white-space: pre-wrap;">License Text:
PYTHON SOFTWARE FOUNDATION LICENSE VERSION 2

     1. This LICENSE AGREEMENT is between the Python Software Foundation (&quot;PSF&quot;), and the Individual or Organization (&quot;Licensee&quot;) accessing and otherwise using this software (&quot;Python&quot;) in source or binary form and its associated documentation.

     2. Subject to the terms and conditions of this License Agreement, PSF hereby grants Licensee a nonexclusive, royalty-free, world-wide license to reproduce, analyze, test, perform and/or display publicly, prepare derivative works, distribute, and otherwise use Python alone or in any derivative version, provided, however, that PSF&#x27;s License Agreement and PSF&#x27;s notice of copyright, i.e., &quot;Copyright (c) 2001, 2002, 2003, 2004, 2005, 2006 Python Software Foundation; All Rights Reserved&quot; are retained in Python alone or in any derivative version prepared by Licensee.

     3. In the event Licensee prepares a derivative work that is based on or incorporates Python or any part thereof, and wants to make the derivative work available to others as provided herein, then Licensee hereby agrees to include in any such work a brief summary of the changes made to Python.

     4. PSF is making Python available to Licensee on an &quot;AS IS&quot; basis. PSF MAKES NO REPRESENTATIONS OR WARRANTIES, EXPRESS OR IMPLIED. BY WAY OF EXAMPLE, BUT NOT LIMITATION, PSF MAKES NO AND DISCLAIMS ANY REPRESENTATION OR WARRANTY OF MERCHANTABILITY OR FITNESS FOR ANY PARTICULAR PURPOSE OR THAT THE USE OF PYTHON WILL NOT INFRINGE ANY THIRD PARTY RIGHTS.

     5. PSF SHALL NOT BE LIABLE TO LICENSEE OR ANY OTHER USERS OF PYTHON FOR ANY INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES OR LOSS AS A RESULT OF MODIFYING, DISTRIBUTING, OR OTHERWISE USING PYTHON, OR ANY DERIVATIVE THEREOF, EVEN IF ADVISED OF THE POSSIBILITY THEREOF.

     6. This License Agreement will automatically terminate upon a material breach of its terms and conditions.

     7. Nothing in this License Agreement shall be deemed to create any relationship of agency, partnership, or joint venture between PSF and Licensee. This License Agreement does not grant permission to use PSF trademarks or trade name in a trademark sense to endorse or promote products or services of Licensee, or any third party.

     8. By copying, installing or otherwise using Python, Licensee agrees to be bound by the terms and conditions of this License Agreement.


BEOPEN.COM LICENSE AGREEMENT FOR PYTHON 2.0

BEOPEN PYTHON OPEN SOURCE LICENSE AGREEMENT VERSION 1

     1. This LICENSE AGREEMENT is between BeOpen.com (&quot;BeOpen&quot;), having an office at 160 Saratoga Avenue, Santa Clara, CA 95051, and the Individual or Organization (&quot;Licensee&quot;) accessing and otherwise using this software in source or binary form and its associated documentation (&quot;the Software&quot;).

     2. Subject to the terms and conditions of this BeOpen Python License Agreement, BeOpen hereby grants Licensee a non-exclusive, royalty-free, world-wide license to reproduce, analyze, test, perform and/or display publicly, prepare derivative works, distribute, and otherwise use the Software alone or in any derivative version, provided, however, that the BeOpen Python License is retained in the Software, alone or in any derivative version prepared by Licensee.

     3. BeOpen is making the Software available to Licensee on an &quot;AS IS&quot; basis. BEOPEN MAKES NO REPRESENTATIONS OR WARRANTIES, EXPRESS OR IMPLIED. BY WAY OF EXAMPLE, BUT NOT LIMITATION, BEOPEN MAKES NO AND DISCLAIMS ANY REPRESENTATION OR WARRANTY OF MERCHANTABILITY OR FITNESS FOR ANY PARTICULAR PURPOSE OR THAT THE USE OF THE SOFTWARE WILL NOT INFRINGE ANY THIRD PARTY RIGHTS.

     4. BEOPEN SHALL NOT BE LIABLE TO LICENSEE OR ANY OTHER USERS OF THE SOFTWARE FOR ANY INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES OR LOSS AS A RESULT OF USING, MODIFYING OR DISTRIBUTING THE SOFTWARE, OR ANY DERIVATIVE THEREOF, EVEN IF ADVISED OF THE POSSIBILITY THEREOF.

     5. This License Agreement will automatically terminate upon a material breach of its terms and conditions.

     6. This License Agreement shall be governed by and interpreted in all respects by the law of the State of California, excluding conflict of law provisions. Nothing in this License Agreement shall be deemed to create any relationship of agency, partnership, or joint venture between BeOpen and Licensee. This License Agreement does not grant permission to use BeOpen trademarks or trade names in a trademark sense to endorse or promote products or services of Licensee, or any third party. As an exception, the &quot;BeOpen Python&quot; logos available at http://www.pythonlabs.com/logos.html may be used according to the permissions granted on that web page.

     7. By copying, installing or otherwise using the software, Licensee agrees to be bound by the terms and conditions of this License Agreement.


CNRI OPEN SOURCE LICENSE AGREEMENT (for Python 1.6b1)

IMPORTANT: PLEASE READ THE FOLLOWING AGREEMENT CAREFULLY.

BY CLICKING ON &quot;ACCEPT&quot; WHERE INDICATED BELOW, OR BY COPYING, INSTALLING OR OTHERWISE USING PYTHON 1.6, beta 1 SOFTWARE, YOU ARE DEEMED TO HAVE AGREED TO THE TERMS AND CONDITIONS OF THIS LICENSE AGREEMENT.

     1. This LICENSE AGREEMENT is between the Corporation for National Research Initiatives, having an office at 1895 Preston White Drive, Reston, VA 20191 (&quot;CNRI&quot;), and the Individual or Organization (&quot;Licensee&quot;) accessing and otherwise using Python 1.6, beta 1 software in source or binary form and its associated documentation, as released at the www.python.org Internet site on August 4, 2000 (&quot;Python 1.6b1&quot;).

     2. Subject to the terms and conditions of this License Agreement, CNRI hereby grants Licensee a non-exclusive, royalty-free, world-wide license to reproduce, analyze, test, perform and/or display publicly, prepare derivative works, distribute, and otherwise use Python 1.6b1 alone or in any derivative version, provided, however, that CNRIs License Agreement is retained in Python 1.6b1, alone or in any derivative version prepared by Licensee.

     Alternately, in lieu of CNRIs License Agreement, Licensee may substitute the following text (omitting the quotes): &quot;Python 1.6, beta 1, is made available subject to the terms and conditions in CNRIs License Agreement. This Agreement may be located on the Internet using the following unique, persistent identifier (known as a handle): 1895.22/1011. This Agreement may also be obtained from a proxy server on the Internet using the URL:http://hdl.handle.net/1895.22/1011&quot;.

     3. In the event Licensee prepares a derivative work that is based on or incorporates Python 1.6b1 or any part thereof, and wants to make the derivative work available to the public as provided herein, then Licensee hereby agrees to indicate in any such work the nature of the modifications made to Python 1.6b1.

     4. CNRI is making Python 1.6b1 available to Licensee on an &quot;AS IS&quot; basis. CNRI MAKES NO REPRESENTATIONS OR WARRANTIES, EXPRESS OR IMPLIED. BY WAY OF EXAMPLE, BUT NOT LIMITATION, CNRI MAKES NO AND DISCLAIMS ANY REPRESENTATION OR WARRANTY OF MERCHANTABILITY OR FITNESS FOR ANY PARTICULAR PURPOSE OR THAT THE USE OF PYTHON 1.6b1 WILL NOT INFRINGE ANY THIRD PARTY RIGHTS.

     5. CNRI SHALL NOT BE LIABLE TO LICENSEE OR ANY OTHER USERS OF THE SOFTWARE FOR ANY INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES OR LOSS AS A RESULT OF USING, MODIFYING OR DISTRIBUTING PYTHON 1.6b1, OR ANY DERIVATIVE THEREOF, EVEN IF ADVISED OF THE POSSIBILITY THEREOF.

     6. This License Agreement will automatically terminate upon a material breach of its terms and conditions.

     7. This License Agreement shall be governed by and interpreted in all respects by the law of the State of Virginia, excluding conflict of law provisions. Nothing in this License Agreement shall be deemed to create any relationship of agency, partnership, or joint venture between CNRI and Licensee. This License Agreement does not grant permission to use CNRI trademarks or trade name in a trademark sense to endorse or promote products or services of Licensee, or any third party.

     8. By clicking on the &quot;ACCEPT&quot; button where indicated, or by copying, installing or otherwise using Python 1.6b1, Licensee agrees to be bound by the terms and conditions of this License Agreement.

ACCEPT


CWI LICENSE AGREEMENT FOR PYTHON 0.9.0 THROUGH 1.2

Copyright (c) 1991 - 1995, Stichting Mathematisch Centrum Amsterdam, The Netherlands. All rights reserved.

     Permission to use, copy, modify, and distribute this software and its documentation for any purpose and without fee is hereby granted, provided that the above copyright notice appear in all copies and that both that copyright notice and this permission notice appear in supporting documentation, and that the name of Stichting Mathematisch Centrum or CWI not be used in advertising or publicity pertaining to distribution of the software without specific, written prior permission.

     STICHTING MATHEMATISCH CENTRUM DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS SOFTWARE, INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS, IN NO EVENT SHALL STICHTING MATHEMATISCH CENTRUM BE LIABLE FOR ANY SPECIAL, INDIRECT OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.

</div>
                <br/>
                <div style="padding: 10px 0px 0px 21px; font-weight: bold;" id=L6>6. CC BY 4.0</div>
                <div style="padding: 10px 0px 0px 21px; white-space: pre-wrap;">License Text:
Creative Commons Attribution 4.0 International

 Creative Commons Corporation (“Creative Commons”) is not a law firm and does not provide legal services or legal advice. Distribution of Creative Commons public licenses does not create a lawyer-client or other relationship. Creative Commons makes its licenses and related information available on an “as-is” basis. Creative Commons gives no warranties regarding its licenses, any material licensed under their terms and conditions, or any related information. Creative Commons disclaims all liability for damages resulting from their use to the fullest extent possible.

Using Creative Commons Public Licenses

Creative Commons public licenses provide a standard set of terms and conditions that creators and other rights holders may use to share original works of authorship and other material subject to copyright and certain other rights specified in the public license below. The following considerations are for informational purposes only, are not exhaustive, and do not form part of our licenses.

Considerations for licensors: Our public licenses are intended for use by those authorized to give the public permission to use material in ways otherwise restricted by copyright and certain other rights. Our licenses are irrevocable. Licensors should read and understand the terms and conditions of the license they choose before applying it. Licensors should also secure all rights necessary before applying our licenses so that the public can reuse the material as expected. Licensors should clearly mark any material not subject to the license. This includes other CC-licensed material, or material used under an exception or limitation to copyright. More considerations for licensors.

Considerations for the public: By using one of our public licenses, a licensor grants the public permission to use the licensed material under specified terms and conditions. If the licensor’s permission is not necessary for any reason–for example, because of any applicable exception or limitation to copyright–then that use is not regulated by the license. Our licenses grant only permissions under copyright and certain other rights that a licensor has authority to grant. Use of the licensed material may still be restricted for other reasons, including because others have copyright or other rights in the material. A licensor may make special requests, such as asking that all changes be marked or described. Although not required by our licenses, you are encouraged to respect those requests where reasonable. More considerations for the public.

Creative Commons Attribution 4.0 International Public License

By exercising the Licensed Rights (defined below), You accept and agree to be bound by the terms and conditions of this Creative Commons Attribution 4.0 International Public License (&quot;Public License&quot;). To the extent this Public License may be interpreted as a contract, You are granted the Licensed Rights in consideration of Your acceptance of these terms and conditions, and the Licensor grants You such rights in consideration of benefits the Licensor receives from making the Licensed Material available under these terms and conditions.

Section 1 – Definitions.

     a.	Adapted Material means material subject to Copyright and Similar Rights that is derived from or based upon the Licensed Material and in which the Licensed Material is translated, altered, arranged, transformed, or otherwise modified in a manner requiring permission under the Copyright and Similar Rights held by the Licensor. For purposes of this Public License, where the Licensed Material is a musical work, performance, or sound recording, Adapted Material is always produced where the Licensed Material is synched in timed relation with a moving image.

     b.	Adapter&#x27;s License means the license You apply to Your Copyright and Similar Rights in Your contributions to Adapted Material in accordance with the terms and conditions of this Public License.

     c.	Copyright and Similar Rights means copyright and/or similar rights closely related to copyright including, without limitation, performance, broadcast, sound recording, and Sui Generis Database Rights, without regard to how the rights are labeled or categorized. For purposes of this Public License, the rights specified in Section 2(b)(1)-(2) are not Copyright and Similar Rights.

     d.	Effective Technological Measures means those measures that, in the absence of proper authority, may not be circumvented under laws fulfilling obligations under Article 11 of the WIPO Copyright Treaty adopted on December 20, 1996, and/or similar international agreements.

     e.	Exceptions and Limitations means fair use, fair dealing, and/or any other exception or limitation to Copyright and Similar Rights that applies to Your use of the Licensed Material.

     f.	Licensed Material means the artistic or literary work, database, or other material to which the Licensor applied this Public License.

     g.	Licensed Rights means the rights granted to You subject to the terms and conditions of this Public License, which are limited to all Copyright and Similar Rights that apply to Your use of the Licensed Material and that the Licensor has authority to license.

     h.	Licensor means the individual(s) or entity(ies) granting rights under this Public License.

     i.	Share means to provide material to the public by any means or process that requires permission under the Licensed Rights, such as reproduction, public display, public performance, distribution, dissemination, communication, or importation, and to make material available to the public including in ways that members of the public may access the material from a place and at a time individually chosen by them.

     j.	Sui Generis Database Rights means rights other than copyright resulting from Directive 96/9/EC of the European Parliament and of the Council of 11 March 1996 on the legal protection of databases, as amended and/or succeeded, as well as other essentially equivalent rights anywhere in the world.

     k.	You means the individual or entity exercising the Licensed Rights under this Public License. Your has a corresponding meaning.

Section 2 – Scope.

     a.	License grant.

          1. Subject to the terms and conditions of this Public License, the Licensor hereby grants You a worldwide, royalty-free, non-sublicensable, non-exclusive, irrevocable license to exercise the Licensed Rights in the Licensed Material to:

               A. reproduce and Share the Licensed Material, in whole or in part; and

               B. produce, reproduce, and Share Adapted Material.

          2. Exceptions and Limitations. For the avoidance of doubt, where Exceptions and Limitations apply to Your use, this Public License does not apply, and You do not need to comply with its terms and conditions.

          3. Term. The term of this Public License is specified in Section 6(a).

          4. Media and formats; technical modifications allowed. The Licensor authorizes You to exercise the Licensed Rights in all media and formats whether now known or hereafter created, and to make technical modifications necessary to do so. The Licensor waives and/or agrees not to assert any right or authority to forbid You from making technical modifications necessary to exercise the Licensed Rights, including technical modifications necessary to circumvent Effective Technological Measures. For purposes of this Public License, simply making modifications authorized by this Section 2(a)(4) never produces Adapted Material.

          5. Downstream recipients.

               A. Offer from the Licensor – Licensed Material. Every recipient of the Licensed Material automatically receives an offer from the Licensor to exercise the Licensed Rights under the terms and conditions of this Public License.

               B. No downstream restrictions. You may not offer or impose any additional or different terms or conditions on, or apply any Effective Technological Measures to, the Licensed Material if doing so restricts exercise of the Licensed Rights by any recipient of the Licensed Material.

          6.  No endorsement. Nothing in this Public License constitutes or may be construed as permission to assert or imply that You are, or that Your use of the Licensed Material is, connected with, or sponsored, endorsed, or granted official status by, the Licensor or others designated to receive attribution as provided in Section 3(a)(1)(A)(i).

b. Other rights.

          1. Moral rights, such as the right of integrity, are not licensed under this Public License, nor are publicity, privacy, and/or other similar personality rights; however, to the extent possible, the Licensor waives and/or agrees not to assert any such rights held by the Licensor to the limited extent necessary to allow You to exercise the Licensed Rights, but not otherwise.

          2. Patent and trademark rights are not licensed under this Public License.

          3. To the extent possible, the Licensor waives any right to collect royalties from You for the exercise of the Licensed Rights, whether directly or through a collecting society under any voluntary or waivable statutory or compulsory licensing scheme. In all other cases the Licensor expressly reserves any right to collect such royalties.

Section 3 – License Conditions.

Your exercise of the Licensed Rights is expressly made subject to the following conditions.

     a.	Attribution.

          1. If You Share the Licensed Material (including in modified form), You must:

               A. retain the following if it is supplied by the Licensor with the Licensed Material:

                    i. identification of the creator(s) of the Licensed Material and any others designated to receive attribution, in any reasonable manner requested by the Licensor (including by pseudonym if designated);

                    ii. a copyright notice;

                    iii. a notice that refers to this Public License;

                    iv.	a notice that refers to the disclaimer of warranties;

                    v. a URI or hyperlink to the Licensed Material to the extent reasonably practicable;

               B. indicate if You modified the Licensed Material and retain an indication of any previous modifications; and

               C. indicate the Licensed Material is licensed under this Public License, and include the text of, or the URI or hyperlink to, this Public License.

          2. You may satisfy the conditions in Section 3(a)(1) in any reasonable manner based on the medium, means, and context in which You Share the Licensed Material. For example, it may be reasonable to satisfy the conditions by providing a URI or hyperlink to a resource that includes the required information.

          3. If requested by the Licensor, You must remove any of the information required by Section 3(a)(1)(A) to the extent reasonably practicable.

          4. If You Share Adapted Material You produce, the Adapter&#x27;s License You apply must not prevent recipients of the Adapted Material from complying with this Public License.

Section 4 – Sui Generis Database Rights.

Where the Licensed Rights include Sui Generis Database Rights that apply to Your use of the Licensed Material:

     a.	for the avoidance of doubt, Section 2(a)(1) grants You the right to extract, reuse, reproduce, and Share all or a substantial portion of the contents of the database;

     b.	if You include all or a substantial portion of the database contents in a database in which You have Sui Generis Database Rights, then the database in which You have Sui Generis Database Rights (but not its individual contents) is Adapted Material; and

     c.	You must comply with the conditions in Section 3(a) if You Share all or a substantial portion of the contents of the database.
For the avoidance of doubt, this Section 4 supplements and does not replace Your obligations under this Public License where the Licensed Rights include other Copyright and Similar Rights.

Section 5 – Disclaimer of Warranties and Limitation of Liability.

     a.	Unless otherwise separately undertaken by the Licensor, to the extent possible, the Licensor offers the Licensed Material as-is and as-available, and makes no representations or warranties of any kind concerning the Licensed Material, whether express, implied, statutory, or other. This includes, without limitation, warranties of title, merchantability, fitness for a particular purpose, non-infringement, absence of latent or other defects, accuracy, or the presence or absence of errors, whether or not known or discoverable. Where disclaimers of warranties are not allowed in full or in part, this disclaimer may not apply to You.

     b.	To the extent possible, in no event will the Licensor be liable to You on any legal theory (including, without limitation, negligence) or otherwise for any direct, special, indirect, incidental, consequential, punitive, exemplary, or other losses, costs, expenses, or damages arising out of this Public License or use of the Licensed Material, even if the Licensor has been advised of the possibility of such losses, costs, expenses, or damages. Where a limitation of liability is not allowed in full or in part, this limitation may not apply to You.

     c.	The disclaimer of warranties and limitation of liability provided above shall be interpreted in a manner that, to the extent possible, most closely approximates an absolute disclaimer and waiver of all liability.

Section 6 – Term and Termination.

     a.	This Public License applies for the term of the Copyright and Similar Rights licensed here. However, if You fail to comply with this Public License, then Your rights under this Public License terminate automatically.

     b.	Where Your right to use the Licensed Material has terminated under Section 6(a), it reinstates:

          1. automatically as of the date the violation is cured, provided it is cured within 30 days of Your discovery of the violation; or

          2. upon express reinstatement by the Licensor.

     c.	For the avoidance of doubt, this Section 6(b) does not affect any right the Licensor may have to seek remedies for Your violations of this Public License.

     d.	For the avoidance of doubt, the Licensor may also offer the Licensed Material under separate terms or conditions or stop distributing the Licensed Material at any time; however, doing so will not terminate this Public License.

     e.	Sections 1, 5, 6, 7, and 8 survive termination of this Public License.

Section 7 – Other Terms and Conditions.

     a.	The Licensor shall not be bound by any additional or different terms or conditions communicated by You unless expressly agreed.

     b.	Any arrangements, understandings, or agreements regarding the Licensed Material not stated herein are separate from and independent of the terms and conditions of this Public License.

Section 8 – Interpretation.

     a.	For the avoidance of doubt, this Public License does not, and shall not be interpreted to, reduce, limit, restrict, or impose conditions on any use of the Licensed Material that could lawfully be made without permission under this Public License.

     b.	To the extent possible, if any provision of this Public License is deemed unenforceable, it shall be automatically reformed to the minimum extent necessary to make it enforceable. If the provision cannot be reformed, it shall be severed from this Public License without affecting the enforceability of the remaining terms and conditions.

     c.	No term or condition of this Public License will be waived and no failure to comply consented to unless expressly agreed to by the Licensor.

     d.	Nothing in this Public License constitutes or may be interpreted as a limitation upon, or waiver of, any privileges and immunities that apply to the Licensor or You, including from the legal processes of any jurisdiction or authority.

Creative Commons is not a party to its public licenses. Notwithstanding, Creative Commons may elect to apply one of its public licenses to material it publishes and in those instances will be considered the “Licensor.” Except for the limited purpose of indicating that material is shared under a Creative Commons public license or as otherwise permitted by the Creative Commons policies published at creativecommons.org/policies, Creative Commons does not authorize the use of the trademark “Creative Commons” or any other trademark or logo of Creative Commons without its prior written consent including, without limitation, in connection with any unauthorized modifications to any of its public licenses or any other arrangements, understandings, or agreements concerning use of licensed material. For the avoidance of doubt, this paragraph does not form part of the public licenses.

Creative Commons may be contacted at creativecommons.org.

</div>
                <br/>
                <div style="padding: 10px 0px 0px 21px; font-weight: bold;" id=L7>7. Blue Oak Model License 1.0.0</div>
                <div style="padding: 10px 0px 0px 21px; white-space: pre-wrap;">License Text:
# Blue Oak Model License

Version 1.0.0

## Purpose

This license gives everyone as much permission to work with
this software as possible, while protecting contributors
from liability.

## Acceptance

In order to receive this license, you must agree to its
rules.  The rules of this license are both obligations
under that agreement and conditions to your license.
You must not do anything with this software that triggers
a rule that you cannot or will not follow.

## Copyright

Each contributor licenses you to do everything with this
software that would otherwise infringe that contributor&#x27;s
copyright in it.

## Notices

You must ensure that everyone who gets a copy of
any part of this software from you, with or without
changes, also gets the text of this license or a link to
&lt;https://blueoakcouncil.org/license/1.0.0&gt;.

## Excuse

If anyone notifies you in writing that you have not
complied with [Notices](#notices), you can keep your
license by taking all practical steps to comply within 30
days after the notice.  If you do not do so, your license
ends immediately.

## Patent

Each contributor licenses you to do everything with this
software that would otherwise infringe any patent claims
they can license or become able to license.

## Reliability

No contributor can revoke this license.

## No Liability

***As far as the law allows, this software comes as is,
without any warranty or condition, and no contributor
will be liable to anyone for any damages related to this
software or this license, under any kind of legal claim.***

</div>
                <br/>
                <div style="padding: 10px 0px 0px 21px; font-weight: bold;" id=L8>8. Apache-2.0</div>
                <div style="padding: 10px 0px 0px 21px; white-space: pre-wrap;">License Text:
Apache License
Version 2.0, January 2004
http://www.apache.org/licenses/

TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION

1. Definitions.

&quot;License&quot; shall mean the terms and conditions for use, reproduction, and distribution as defined by Sections 1 through 9 of this document.

&quot;Licensor&quot; shall mean the copyright owner or entity authorized by the copyright owner that is granting the License.

&quot;Legal Entity&quot; shall mean the union of the acting entity and all other entities that control, are controlled by, or are under common control with that entity. For the purposes of this definition, &quot;control&quot; means (i) the power, direct or indirect, to cause the direction or management of such entity, whether by contract or otherwise, or (ii) ownership of fifty percent (50%) or more of the outstanding shares, or (iii) beneficial ownership of such entity.

&quot;You&quot; (or &quot;Your&quot;) shall mean an individual or Legal Entity exercising permissions granted by this License.

&quot;Source&quot; form shall mean the preferred form for making modifications, including but not limited to software source code, documentation source, and configuration files.

&quot;Object&quot; form shall mean any form resulting from mechanical transformation or translation of a Source form, including but not limited to compiled object code, generated documentation, and conversions to other media types.

&quot;Work&quot; shall mean the work of authorship, whether in Source or Object form, made available under the License, as indicated by a copyright notice that is included in or attached to the work (an example is provided in the Appendix below).

&quot;Derivative Works&quot; shall mean any work, whether in Source or Object form, that is based on (or derived from) the Work and for which the editorial revisions, annotations, elaborations, or other modifications represent, as a whole, an original work of authorship. For the purposes of this License, Derivative Works shall not include works that remain separable from, or merely link (or bind by name) to the interfaces of, the Work and Derivative Works thereof.

&quot;Contribution&quot; shall mean any work of authorship, including the original version of the Work and any modifications or additions to that Work or Derivative Works thereof, that is intentionally submitted to Licensor for inclusion in the Work by the copyright owner or by an individual or Legal Entity authorized to submit on behalf of the copyright owner. For the purposes of this definition, &quot;submitted&quot; means any form of electronic, verbal, or written communication sent to the Licensor or its representatives, including but not limited to communication on electronic mailing lists, source code control systems, and issue tracking systems that are managed by, or on behalf of, the Licensor for the purpose of discussing and improving the Work, but excluding communication that is conspicuously marked or otherwise designated in writing by the copyright owner as &quot;Not a Contribution.&quot;

&quot;Contributor&quot; shall mean Licensor and any individual or Legal Entity on behalf of whom a Contribution has been received by Licensor and subsequently incorporated within the Work.

2. Grant of Copyright License. Subject to the terms and conditions of this License, each Contributor hereby grants to You a perpetual, worldwide, non-exclusive, no-charge, royalty-free, irrevocable copyright license to reproduce, prepare Derivative Works of, publicly display, publicly perform, sublicense, and distribute the Work and such Derivative Works in Source or Object form.

3. Grant of Patent License. Subject to the terms and conditions of this License, each Contributor hereby grants to You a perpetual, worldwide, non-exclusive, no-charge, royalty-free, irrevocable (except as stated in this section) patent license to make, have made, use, offer to sell, sell, import, and otherwise transfer the Work, where such license applies only to those patent claims licensable by such Contributor that are necessarily infringed by their Contribution(s) alone or by combination of their Contribution(s) with the Work to which such Contribution(s) was submitted. If You institute patent litigation against any entity (including a cross-claim or counterclaim in a lawsuit) alleging that the Work or a Contribution incorporated within the Work constitutes direct or contributory patent infringement, then any patent licenses granted to You under this License for that Work shall terminate as of the date such litigation is filed.

4. Redistribution. You may reproduce and distribute copies of the Work or Derivative Works thereof in any medium, with or without modifications, and in Source or Object form, provided that You meet the following conditions:

     (a) You must give any other recipients of the Work or Derivative Works a copy of this License; and

     (b) You must cause any modified files to carry prominent notices stating that You changed the files; and

     (c) You must retain, in the Source form of any Derivative Works that You distribute, all copyright, patent, trademark, and attribution notices from the Source form of the Work, excluding those notices that do not pertain to any part of the Derivative Works; and

     (d) If the Work includes a &quot;NOTICE&quot; text file as part of its distribution, then any Derivative Works that You distribute must include a readable copy of the attribution notices contained within such NOTICE file, excluding those notices that do not pertain to any part of the Derivative Works, in at least one of the following places: within a NOTICE text file distributed as part of the Derivative Works; within the Source form or documentation, if provided along with the Derivative Works; or, within a display generated by the Derivative Works, if and wherever such third-party notices normally appear. The contents of the NOTICE file are for informational purposes only and do not modify the License. You may add Your own attribution notices within Derivative Works that You distribute, alongside or as an addendum to the NOTICE text from the Work, provided that such additional attribution notices cannot be construed as modifying the License.

     You may add Your own copyright statement to Your modifications and may provide additional or different license terms and conditions for use, reproduction, or distribution of Your modifications, or for any such Derivative Works as a whole, provided Your use, reproduction, and distribution of the Work otherwise complies with the conditions stated in this License.

5. Submission of Contributions. Unless You explicitly state otherwise, any Contribution intentionally submitted for inclusion in the Work by You to the Licensor shall be under the terms and conditions of this License, without any additional terms or conditions. Notwithstanding the above, nothing herein shall supersede or modify the terms of any separate license agreement you may have executed with Licensor regarding such Contributions.

6. Trademarks. This License does not grant permission to use the trade names, trademarks, service marks, or product names of the Licensor, except as required for reasonable and customary use in describing the origin of the Work and reproducing the content of the NOTICE file.

7. Disclaimer of Warranty. Unless required by applicable law or agreed to in writing, Licensor provides the Work (and each Contributor provides its Contributions) on an &quot;AS IS&quot; BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied, including, without limitation, any warranties or conditions of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A PARTICULAR PURPOSE. You are solely responsible for determining the appropriateness of using or redistributing the Work and assume any risks associated with Your exercise of permissions under this License.

8. Limitation of Liability. In no event and under no legal theory, whether in tort (including negligence), contract, or otherwise, unless required by applicable law (such as deliberate and grossly negligent acts) or agreed to in writing, shall any Contributor be liable to You for damages, including any direct, indirect, special, incidental, or consequential damages of any character arising as a result of this License or out of the use or inability to use the Work (including but not limited to damages for loss of goodwill, work stoppage, computer failure or malfunction, or any and all other commercial damages or losses), even if such Contributor has been advised of the possibility of such damages.

9. Accepting Warranty or Additional Liability. While redistributing the Work or Derivative Works thereof, You may choose to offer, and charge a fee for, acceptance of support, warranty, indemnity, or other liability obligations and/or rights consistent with this License. However, in accepting such obligations, You may act only on Your own behalf and on Your sole responsibility, not on behalf of any other Contributor, and only if You agree to indemnify, defend, and hold each Contributor harmless for any liability incurred by, or claims asserted against, such Contributor by reason of your accepting any such warranty or additional liability.

END OF TERMS AND CONDITIONS

APPENDIX: How to apply the Apache License to your work.

To apply the Apache License to your work, attach the following boilerplate notice, with the fields enclosed by brackets &quot;[]&quot; replaced with your own identifying information. (Don&#x27;t include the brackets!)  The text should be enclosed in the appropriate comment syntax for the file format. We also recommend that a file or class name and description of purpose be included on the same &quot;printed page&quot; as the copyright notice for easier identification within third-party archives.

Copyright [yyyy] [name of copyright owner]

Licensed under the Apache License, Version 2.0 (the &quot;License&quot;);
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an &quot;AS IS&quot; BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

</div>
                <br/>
                <div style="padding: 10px 0px 0px 21px; font-weight: bold;" id=L9>9. BSD 2</div>
                <div style="padding: 10px 0px 0px 21px; white-space: pre-wrap;">License Text:
Copyright (c) &lt;year&gt; &lt;owner&gt; 

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

1. Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.

2. Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS &quot;AS IS&quot; AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

</div>
                <br/>
                <div style="padding: 10px 0px 0px 21px; font-weight: bold;" id=L10>10. Unlicense</div>
                <div style="padding: 10px 0px 0px 21px; white-space: pre-wrap;">License Text:
This is free and unencumbered software released into the public domain.

Anyone is free to copy, modify, publish, use, compile, sell, or distribute this software, either in source code form or as a compiled binary, for any purpose, commercial or non-commercial, and by any means.

In jurisdictions that recognize copyright laws, the author or authors of this software dedicate any and all copyright interest in the software to the public domain. We make this dedication for the benefit of the public at large and to the detriment of our heirs and
successors. We intend this dedication to be an overt act of relinquishment in perpetuity of all present and future rights to this software under copyright law.

THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

For more information, please refer to &lt;http://unlicense.org/&gt;

</div>
                <br/>
                <div style="padding: 10px 0px 0px 21px; font-weight: bold;" id=L11>11. BSD Zero</div>
                <div style="padding: 10px 0px 0px 21px; white-space: pre-wrap;">License Text:
Copyright (C) YEAR by AUTHOR EMAIL

Permission to use, copy, modify, and/or distribute this software for any purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED &quot;AS IS&quot; AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.

</div>
                <br/>

                <div style="padding: 10px 0px 0px 21px; font-weight: bold;" id=L12>12. CC0-1.0</div>
                <div style="padding: 10px 0px 0px 21px; white-space: pre-wrap;">License Text:
Creative Commons Legal Code

CC0 1.0 Universal

CREATIVE COMMONS CORPORATION IS NOT A LAW FIRM AND DOES NOT PROVIDE LEGAL SERVICES. DISTRIBUTION OF THIS DOCUMENT DOES NOT CREATE AN ATTORNEY-CLIENT RELATIONSHIP. CREATIVE COMMONS PROVIDES THIS INFORMATION ON AN &quot;AS-IS&quot; BASIS. CREATIVE COMMONS MAKES NO WARRANTIES REGARDING THE USE OF THIS DOCUMENT OR THE INFORMATION OR WORKS PROVIDED HEREUNDER, AND DISCLAIMS LIABILITY FOR DAMAGES RESULTING FROM THE USE OF THIS DOCUMENT OR THE INFORMATION OR WORKS PROVIDED HEREUNDER.

Statement of Purpose

The laws of most jurisdictions throughout the world automatically confer exclusive Copyright and Related Rights (defined below) upon the creator and subsequent owner(s) (each and all, an &quot;owner&quot;) of an original work of authorship and/or a database (each, a &quot;Work&quot;).

Certain owners wish to permanently relinquish those rights to a Work for the purpose of contributing to a commons of creative, cultural and scientific works (&quot;Commons&quot;) that the public can reliably and without fear of later claims of infringement build upon, modify, incorporate in other works, reuse and redistribute as freely as possible in any form whatsoever and for any purposes, including without limitation commercial purposes. These owners may contribute to the Commons to promote the ideal of a free culture and the further production of creative, cultural and scientific works, or to gain reputation or greater distribution for their Work in part through the use and efforts of others.

For these and/or other purposes and motivations, and without any expectation of additional consideration or compensation, the person associating CC0 with a Work (the &quot;Affirmer&quot;), to the extent that he or she is an owner of Copyright and Related Rights in the Work, voluntarily elects to apply CC0 to the Work and publicly distribute the Work under its terms, with knowledge of his or her Copyright and Related Rights in the Work and the meaning and intended legal effect of CC0 on those rights.

- 1. Copyright and Related Rights. A Work made available under CC0 may be protected by copyright and related or neighboring rights (&quot;Copyright and Related Rights&quot;). Copyright and Related Rights include, but are not limited to, the following:
- i. the right to reproduce, adapt, distribute, perform, display, communicate, and translate a Work;
- ii. moral rights retained by the original author(s) and/or performer(s);
- iii. publicity and privacy rights pertaining to a person&#x27;s image or likeness depicted in a Work;
- iv. rights protecting against unfair competition in regards to a Work, subject to the limitations in paragraph 4(a), below;
- v. rights protecting the extraction, dissemination, use and reuse of data in a Work;
- vi. database rights (such as those arising under Directive 96/9/EC of the European Parliament and of the Council of 11 March 1996 on the legal protection of databases, and under any national implementation thereof, including any amended or successor version of such directive); and
- vii. other similar, equivalent or corresponding rights throughout the world based on applicable law or treaty, and any national implementations thereof.
- 2. Waiver. To the greatest extent permitted by, but not in contravention of, applicable law, Affirmer hereby overtly, fully, permanently, irrevocably and unconditionally waives, abandons, and surrenders all of Affirmer&#x27;s Copyright and Related Rights and associated claims and causes of action, whether now known or unknown (including existing as well as future claims and causes of action), in the Work (i) in all territories worldwide, (ii) for the maximum duration provided by applicable law or treaty (including future time extensions), (iii) in any current or future medium and for any number of copies, and (iv) for any purpose whatsoever, including without limitation commercial, advertising or promotional purposes (the &quot;Waiver&quot;). Affirmer makes the Waiver for the benefit of each member of the public at large and to the detriment of Affirmer&#x27;s heirs and successors, fully intending that such Waiver shall not be subject to revocation, rescission, cancellation, termination, or any other legal or equitable action to disrupt the quiet enjoyment of the Work by the public as contemplated by Affirmer&#x27;s express Statement of Purpose.
- 3. Public License Fallback. Should any part of the Waiver for any reason be judged legally invalid or ineffective under applicable law, then the Waiver shall be preserved to the maximum extent permitted taking into account Affirmer&#x27;s express Statement of Purpose. In addition, to the extent the Waiver is so judged Affirmer hereby grants to each affected person a royalty-free, non transferable, non sublicensable, non exclusive, irrevocable and unconditional license to exercise Affirmer&#x27;s Copyright and Related Rights in the Work (i) in all territories worldwide, (ii) for the maximum duration provided by applicable law or treaty (including future time extensions), (iii) in any current or future medium and for any number of copies, and (iv) for any purpose whatsoever, including without limitation commercial, advertising or promotional purposes (the &quot;License&quot;). The License shall be deemed effective as of the date CC0 was applied by Affirmer to the Work. Should any part of the License for any reason be judged legally invalid or ineffective under applicable law, such partial invalidity or ineffectiveness shall not invalidate the remainder of the License, and in such case Affirmer hereby affirms that he or she will not (i) exercise any of his or her remaining Copyright and Related Rights in the Work or (ii) assert any associated claims and causes of action with respect to the Work, in either case contrary to Affirmer&#x27;s express Statement of Purpose.
- 4. Limitations and Disclaimers.
- a. No trademark or patent rights held by Affirmer are waived, abandoned, surrendered, licensed or otherwise affected by this document.
- b. Affirmer offers the Work as-is and makes no representations or warranties of any kind concerning the Work, express, implied, statutory or otherwise, including without limitation warranties of title, merchantability, fitness for a particular purpose, non infringement, or the absence of latent or other defects, accuracy, or the present or absence of errors, whether or not discoverable, all to the greatest extent permissible under applicable law.
- c. Affirmer disclaims responsibility for clearing rights of other persons that may apply to the Work or any use thereof, including without limitation any person&#x27;s Copyright and Related Rights in the Work. Further, Affirmer disclaims responsibility for obtaining any necessary consents, permissions or other rights required for any use of the Work.
- d. Affirmer understands and acknowledges that Creative Commons is not a party to this document and has no duty or obligation with respect to this CC0 or use of the Work.


</div>
                <br/>

<div style="font-size: 32px; text-align: center;"></div>
</body>
</html>

`;
                this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(whiteSourceHTMLTemplate);
        }

}
